import { formatText } from 'core/i18n';

export const OtpTransferCodeBoxInitialState = {
    isClickedRetryOTPChallenge: false,
    incorrectOtp: false,
    incorrectOtpRetry: false,
    expiredOtpRetry: false,
    incorrectOtpWithoutRetry: false,
    expiredOtpWithoutRetry: false,
    isOtpValidated: false,
    showOtpButton: true,
    errorMessage: '',
};

export const OtpTransferCodeBoxActions = {
    RESET_OTP_STATUS: 'RESET_OTP_STATUS',
    VALIDATE_OTP_OK: 'VALIDATE_OTP_OK',
    VALIDATE_OTP_INCORRECT: 'VALIDATE_OTP_INCORRECT',
    VALIDATE_OTP_INCORRECT_RETRY: 'VALIDATE_OTP_INCORRECT_RETRY',
    VALIDATE_OTP_INCORRECT_NO_RETRY: 'VALIDATE_OTP_INCORRECT_NO_RETRY',
    VALIDATE_EXPIRED_RETRY: 'VALIDATE_EXPIRED_RETRY',
    VALIDATE_EXPIRED_NO_RETRY: 'VALIDATE_EXPIRED_NO_RETRY',
    CHANGE_ERROR_MESSAGE: 'CHANGE_ERROR_MESSAGE',
    RETRY_OTP_CLICK: 'RETRY_OTP_CLICK',
};

export function OtpTransferCodeBoxReducer(state, action) {
    switch (action.type) {
        case OtpTransferCodeBoxActions.RESET_OTP_STATUS:
            return {
                ...state,
                incorrectOtp: false,
                incorrectOtpRetry: false,
                expiredOtpRetry: false,
                showOtpButton: true,
                incorrectOtpWithoutRetry: false,
                expiredOtpWithoutRetry: false,
            };
        case OtpTransferCodeBoxActions.VALIDATE_OTP_OK:
            return {
                ...state,
                isOtpValidated: true,
                showOtpButton: false,
            };
        case OtpTransferCodeBoxActions.VALIDATE_OTP_INCORRECT:
            return {
                ...state,
                incorrectOtp: true,
                errorMessage: formatText('validation-otpFormatInvalid'),
            };
        case OtpTransferCodeBoxActions.VALIDATE_OTP_INCORRECT_RETRY:
            return {
                ...state,
                incorrectOtpRetry: true,
                errorMessage: formatText('validation-otpObsolete'),
            };
        case OtpTransferCodeBoxActions.VALIDATE_OTP_INCORRECT_NO_RETRY:
            return {
                ...state,
                showOtpButton: false,
                incorrectOtpWithoutRetry: true,
                errorMessage: formatText('validation-otpAllTriesMade'),
            };
        case OtpTransferCodeBoxActions.VALIDATE_EXPIRED_RETRY:
            return {
                ...state,
                expiredOtpRetry: true,
                errorMessage: formatText('validation-otpObsolete'),
            };
        case OtpTransferCodeBoxActions.VALIDATE_EXPIRED_NO_RETRY:
            return {
                ...state,
                showOtpButton: false,
                expiredOtpWithoutRetry: true,
                errorMessage: formatText('validation-otpAllTriesMade'),
            };
        case OtpTransferCodeBoxActions.CHANGE_ERROR_MESSAGE:
            return {
                ...state,
                errorMessage: action.payload.errorMessage,
            };
        case OtpTransferCodeBoxActions.RETRY_OTP_CLICK:
            return {
                ...state,
                isClickedRetryOTPChallenge: true,
                errorMessage: '',
            };
        default:
            throw new Error();
    }
}
